import { Link } from 'react-router-dom';
import type { Actor } from '@/mocks/actors';

interface CastListProps {
  actors: Actor[];
}

export default function CastList({ actors }: CastListProps) {
  if (actors.length === 0) {
    return <p className="text-sm text-foreground-600">暂无演员资料。</p>;
  }

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
      {actors.map((actor) => (
        <Link
          key={actor.id}
          to={`/actor/${actor.id}`}
          className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 hover:bg-secondary-100 cursor-pointer"
        >
          <span className="h-14 w-14 flex-shrink-0 overflow-hidden rounded-full bg-background-200">
            <img
              src={actor.avatar}
              alt={`${actor.name} 头像`}
              title={`${actor.name} 演员资料`}
              className="h-full w-full object-cover object-top"
            />
          </span>
          <span className="min-w-0 flex-1">
            <span className="block truncate font-heading text-sm font-semibold text-foreground-950 transition-colors group-hover:text-accent-600">
              {actor.name}
            </span>
            <span className="mt-0.5 block truncate font-label text-xs text-foreground-600">
              {actor.gender} · {actor.birthplace.split(' · ')[1] || actor.birthplace}
            </span>
            <span className="mt-1 block truncate font-label text-[11px] text-secondary-600">
              参演 {actor.works.length} 部作品
            </span>
          </span>
        </Link>
      ))}
    </div>
  );
}